import type { PropsWithChildren } from 'react';

export function Body({ children }: PropsWithChildren) {
  return <div slot="body">{children}</div>;
}
